<template>
  <v-dialog v-model="isOpen" max-width="480">
    <v-card>
      <v-card-title primary-title class="primary white--text">
        Informações
      </v-card-title>

      <v-card-text>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <b>Tamanho: </b> {{ item.size }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <b>Criado em: </b> {{ item.created }} <span v-if="item.userName"> por {{ item.userName }} </span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <b>Modificado: </b> {{ item.modified }} <span v-if="item.userNameUpdate"> por {{ item.userNameUpdate }} </span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="isOpen = false">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GenericInformation',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isOpen: false,
  }),
  watch: {
    open(newValue) {
      this.isOpen = newValue;
    },
    isOpen(newValue) {
      if (!newValue) {
        this.$emit('close');
      }
    },
  },
  beforeMount() {
    this.isOpen = this.open;
  },
};
</script>
